const pkg = {
  version: "v1.3",
  builder: "build-186526",
};
export default pkg;
